import { render, staticRenderFns } from "./SelectModule.vue?vue&type=template&id=c3b39f84&scoped=true&"
import script from "./SelectModule.vue?vue&type=script&lang=js&"
export * from "./SelectModule.vue?vue&type=script&lang=js&"
import style0 from "./SelectModule.vue?vue&type=style&index=0&id=c3b39f84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b39f84",
  null
  
)

export default component.exports